
import { LocationDTO, OperatorDTO, SourceLocationDTO, TripDTO, TripResultDTO } from "../../apiclient/ApiDtos";
import { SearchFormModel } from "../../components/SearchForm";
import SearchCriteria, { LocationType } from "../../models/SearchCriteria";
import FilterCriteria from "../../pages/tripresult/TripSearchFilterModel";

export class TripSearchFsmContext {
    constructor(
        public readonly searchFormModel: SearchFormModel,  
        public readonly searchCriteria: SearchCriteria,
        public readonly searchResults: TripResultDTO[]|null = null,        
        public readonly errorMessage: string | null = null, 
        public readonly isSearchFormExpanded:boolean = false, 
        public readonly filterCriteria: FilterCriteria = new FilterCriteria(), 
        public readonly selectingLocationType: LocationType | null = null, 
        public readonly selectedTripSearchResult: TripResultDTO | null = null,
        public readonly selectedOperator:OperatorDTO | null = null) {
    }

    withSearchCriteria(searchCriteria:SearchCriteria):TripSearchFsmContext {        
        return new TripSearchFsmContext(this.searchFormModel, searchCriteria, this.searchResults, 
            this.errorMessage, this.isSearchFormExpanded);
    }
    
    withFilterCriteria(newFilterCriteria:FilterCriteria):TripSearchFsmContext {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, this.searchResults, 
            this.errorMessage, this.isSearchFormExpanded, newFilterCriteria);
    }

    withSelectingLocationType(selectingLocationType: LocationType) {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, this.searchResults, 
            this.errorMessage, true, this.filterCriteria, selectingLocationType);
    }

    withSearchError(errorMessage: string):TripSearchFsmContext {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, [], 
            errorMessage, this.isSearchFormExpanded, this.filterCriteria);
    }

    withSearchResults(searchResults: TripDTO[]):TripSearchFsmContext {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, searchResults, 
            this.errorMessage, this.isSearchFormExpanded, this.filterCriteria);
    }

    withSelectedTrip(selectedSearchResult: TripDTO):TripSearchFsmContext {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, this.searchResults, 
            this.errorMessage, false, this.filterCriteria, null, selectedSearchResult);
    }

    withSelectedLocation(locationType:LocationType, location:LocationDTO) {
        let searchFormModel = this.searchFormModel;
        if(locationType == 'source') {
            searchFormModel.sourceLocation = <SourceLocationDTO> location;            
            if(searchFormModel.destinationLocation && searchFormModel.destinationLocation.id == searchFormModel.sourceLocation.id) {
                searchFormModel.destinationLocation = null;
            }
        } else {
            searchFormModel.destinationLocation = location;
        }
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, this.searchResults, 
            this.errorMessage, true, this.filterCriteria, null);
    }

    withSelectedOperator(operator:OperatorDTO) {
        return new TripSearchFsmContext(this.searchFormModel, this.searchCriteria, this.searchResults, 
            this.errorMessage, false, this.filterCriteria, null, null, operator);
    }
}
